import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationResponse } from './confirmationResponse.model';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  @Input() message: string;
  @Input() objectText: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() withComment: boolean;
  @Input() warn: boolean;
  @Input() causes: string[];
  @Input() otherWarnMessage: string;
  @Input() otherWarnCauses: string[];
  @Input() infoText: string;

  comments = '';

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  public decline(): void {
    const confirmationResponse = new ConfirmationResponse();
    confirmationResponse.ok = false;
    this.activeModal.close(confirmationResponse);
  }

  public accept(): void {
    const confirmationResponse = new ConfirmationResponse();
    confirmationResponse.ok = true;
    if (this.withComment) {
      confirmationResponse.comment = this.comments;
    }
    this.activeModal.close(confirmationResponse);
  }

  public dismiss(): void {
    this.activeModal.dismiss();
  }

}
